import { compact } from 'lodash-es';
import { Typography, TableList } from 'seagull';
import { jsx as _jsx } from "react/jsx-runtime";
export function RevenueBreakdownRow(props) {
  const items = compact([props.showPeriod && {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "revenue-breakdown-report-row-day",
      variant: "paragraph1",
      noWrap: true,
      children: props.day
    })
  }, props.showCustomer && {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "revenue-breakdown-report-row-customer",
      variant: "paragraph1",
      noWrap: true,
      ellipsis: true,
      children: props.customer || ''
    })
  }, props.showService && {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "revenue-breakdown-report-row-service",
      variant: "paragraph1",
      noWrap: true,
      ellipsis: true,
      children: props.service || ''
    })
  }, {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "revenue-breakdown-report-row-revenue",
      variant: "paragraph1",
      noWrap: true,
      children: props.revenue
    })
  }]);
  return /*#__PURE__*/_jsx(TableList.Row, {
    items: items,
    rowId: props.index,
    "data-testid": "revenue-report-row-".concat(props.index),
    "data-heapid": "revenue-report-row"
  });
}